import React from 'react';
import { Instagram, PlayCircle } from 'lucide-react';

const BG_IMAGE =
  'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1920&q=80';

const BIO_PARAGRAPHS = [
  'Merhaba!',
  'Ben Baturalp Aktepe. 28 yaşındayım. Adnan Menderes Üniversitesi Turist Rehberliği bölümünden mezun oldum. Aynı zamanda The School of Pysical Education Awf Krakow\'da 1 sene boyunca Spor Bilimleri fakültesinde Erasmus programına katıldım. Bu programda ecotourism, active tourism, nordic walking, high-mountain outdoor, winter trekking, ski touring, climbing gibi aktiviteleri başarıyla tamamladım. 2019 yılından beri Turizm Bakanlığı ve Turist Rehberleri Odası\'na bağlı ülkesel turist rehberi olarak çalışmaktayım. Aynı zamanda Türkiye Dağcılık Federasyonu\'na bağlı lisanslı dağcılık faaliyetleri yürütmekteyim. Yaklaşık 10 yıldır Likya Yolu\'nu yürümekte ve aynı zamanda rehberiniz olarak yürüyüşlerinize eşlik etmekteyim.',
  'Yan taraftaki videoda "Go Türkiye" için çekmiş olduğumuz, benim de rehberliğini gerçekleştirdiğim Likya Yolu içeriğini izleyebilirsiniz.',
  'Etkinliklerimizde görüşmek üzere…',
];

const YOUTUBE_ID = 'Q_2nZ_FewdM';

const GuideSection = () => {
  return (
    <section
      className="relative overflow-hidden"
      data-testid="guide-section"
      style={{
        backgroundImage: `url(${BG_IMAGE})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* Dark atmospheric overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0f1a0a]/90 via-[#1a2914]/85 to-[#0b140a]/95" />

      <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* ── Left: Bio text ── */}
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="h-[2px] w-8 bg-[#C8D843]" />
              <span className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#C8D843]">
                Rehberiniz
              </span>
            </div>

            <h2
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              Baturalp Aktepe
            </h2>

            <div className="space-y-4 text-white/85 text-[15px] md:text-base leading-relaxed">
              {BIO_PARAGRAPHS.map((p, i) => (
                <p key={i} className={i === 0 ? 'font-semibold text-white' : ''}>
                  {p}
                </p>
              ))}
            </div>

            <a
              href="https://instagram.com/batouristic"
              target="_blank"
              rel="noreferrer"
              data-testid="guide-instagram-link"
              className="mt-8 inline-flex items-center gap-2 text-[#C8D843] hover:text-white transition-colors text-sm font-semibold"
            >
              <Instagram size={16} />
              @batouristic
            </a>

            <div className="mt-8 h-[3px] w-16 bg-[#C8D843] rounded-full" />
          </div>

          {/* ── Right: YouTube video ── */}
          <div className="order-1 lg:order-2">
            <div
              className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10 bg-black"
              data-testid="guide-youtube-wrapper"
            >
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${YOUTUBE_ID}?rel=0&modestbranding=1`}
                title="Likya Yolu — Baturalp Aktepe"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>

            <div className="mt-4 flex items-center gap-2 text-white/70 text-xs">
              <PlayCircle size={14} className="text-[#C8D843]" />
              <span>Go Türkiye · Lycian Way · Fethiye</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuideSection;
